// @flow
import React from 'react';

import { FormattedMessage } from 'translations';
import CheckboxField from 'mz-ui-kit/form/CheckboxField';
import config from 'config';

import { BlackLabel } from './elements';

const messages = {
  rideTracking: { id: 'SEARCH_RESULTS.AMENITIES.TRACKING' },
};

type Props = {
  onChange: (param: boolean) => void,
  value: boolean
}

/**
 * Filter Meet and Greet, checkbox used to filter searches by meet & greet
 * @param {Function} onChange
 * @param {Boolean} value
 * @return React.Node
 */
export default function RideTracking ({ onChange, value }: Props) {
  if (!config.SHOW_RIDE_TRACKING_FILTER) return null;

  return (
    <CheckboxField
      input={{
        onChange,
        value
      }}
      label={(
        <BlackLabel>
          <FormattedMessage
            {...messages.rideTracking}
          />
        </BlackLabel>
      )}
    />
  );
}
